const translations = {
  ACTIVATION_LABEL_PASSWORD: 'Introduce la contraseña',
  ACTIVATION_LABEL_PASSWORD_CONFIRMATION: 'Repite la contraseña',
  ACTIVATION_SUCCESS: 'Enhorabuena, tu cuenta se ha activado.',
  ACTIVATION_TITLE: 'Activación de la cuenta',
  ACTIVATION_USER_GREETING: 'Hola:',
  ACTIVATION_DESCRIPTION: 'Completa la activación de tu cuenta eligiendo una contraseña. La contraseña debe contener al menos 8 caracteres, al menos uno mayúsculo, uno numérico y uno especial.',
  ADD_MASTER_USER: 'Añadir cuenta principal',
  ADD_EDITOR_USER: 'Añadir cuenta de editor',
  ADD_BASE_USER: 'Añadir cuenta básica',
  ADD_DIRECTOR_USER: 'Añadir cuenta de director',
  ADD_BUYER_USER: 'Añadir cuenta de comprador',
  ADD_COMPANY: 'Añadir nueva empresa',
  ADD_USER_FIRST_NAME_PLACEHOLDER: 'Nombre',
  ADD_USER_LAST_NAME_PLACEHOLDER: 'Apellido',
  ADD_USER_EMAIL_PLACEHOLDER: 'Correo electrónico',
  ADD_PRODUCT: 'Añadir producto',
  COMPANY_TITLE: 'empresas',
  COMPANY_TITLE_NOT_EDITOR: 'mi empresa',
  COMPANY_CREATION_LABEL: '¿Quieres introducir un nuevo perfil de empresa?',
  COMPANY_CREATION_BUTTON: 'Introducir empresa',
  COMPANY_NUSERS: 'N.Usuarios',
  COMPANY_ORDERSMADE: 'Pedidos realizados',
  COMPANY_OFFICIALDATA: 'datos oficiales',
  COMPANY_BUSINESSINFO: 'Información comercial',
  COMPANY_STRUCTURE_TAB: 'cuenta',
  COMPANY_DOCUMENTS_TAB: 'documentos',
  COMPANY_CONTRACTS_TAB: 'contratos',
  COMPANY_NAME: 'Nombre de la empresa',
  COMPANY_COUNTRY: 'País',
  COMPANY_FISCALCODE: 'Código fiscal',
  COMPANY_VAT: 'Número de IVA',
  COMPANY_REA: 'Número REA',
  COMPANY_CCIAA: 'Número CCIAA',
  COMPANY_DUNS: 'Número de Duns',
  COMPANY_REGISTRATION_NUMBER: 'Número de registro',
  COMPANY_CLIENTCODE: 'Código del cliente',
  COMPANY_LEGALENTITY: 'Naturaleza jurídica',
  COMPANY_CEASED: 'La empresa se da de baja y no puede seleccionarse.',
  COMPANY_DIFFERENT_LEGAL_HEAD_OFFICE: 'El domicilio social de la empresa se encuentra en la provincia de {{province}} y no es posible seleccionarlo.',
  COMPANY_QUESTIONNAIRE: 'Cuestionarios',
  COMPANY_STRUCTURE_EMPTY: 'No hay cuenta MASTER disponible.',
  ERROR_FIELD_MANDATORY: 'Campos obligatorios',
  GENERIC_AT_DATE: 'el',
  GENERIC_AND: 'y',
  GENERIC_ON_DATE: 'el',
  GENERIC_AT_TIME: 'a las',
  GENERIC_ANY: 'Cualquier',
  GENERIC_ACTIVE: 'Activo',
  GENERIC_ASSIGN_USER: 'asignar',
  GENERIC_NOT_ACTIVE: 'No activo',
  GENERIC_BASE: 'Base',
  GENERIC_BUYER: 'Comprador',
  GENERIC_COMPANY: 'empresa',
  GENERIC_COMPANY_NAME: 'denominación',
  GENERIC_CONFIRM: 'confirmar',
  GENERIC_CONFIRM_TITLE: '¿Quieres confirmar?',
  GENERIC_CUSTOMER: 'Cliente',
  GENERIC_DIRECTOR: 'Director',
  GENERIC_EACH: 'cada',
  GENERIC_EDITOR: 'Editor',
  GENERIC_EMAIL: 'correo electrónico',
  GENERIC_INSERTEDBY: 'Añadido por',
  GENERIC_INSERT: 'Introduce',
  GENERIC_LOADING: 'Cargando...',
  GENERIC_MASTER: 'Principal',
  GENERIC_NAME: 'nombre',
  GENERIC_OF: 'de',
  GENERIC_FOR: 'por',
  GENERIC_PAGE: 'página',
  GENERIC_PLACEHOLDER_INSERTHERE: 'Introduce aquí',
  GENERIC_PENDINGREQUESTS: 'solicitudes suspendidas',
  GENERIC_REFUSE: 'rechazar',
  GENERIC_DECLINE: 'cancelar',
  GENERIC_REGISTRATIONSTATUS: 'Estado',
  GENERIC_RESULTS: 'resultados',
  GENERIC_SEARCH: 'buscar',
  GENERIC_SEARCH_BY: 'buscar',
  GENERIC_SHOWALL: 'Mostrar todas',
  GENERIC_ALL: 'todas',
  GENERIC_SUBMIT: 'confirmar',
  GENERIC_SURNAME: 'apellido',
  GENERIC_TYPE: 'Tipología',
  GENERIC_TYPE_CLIENT: 'Cliente',
  GENERIC_TYPE_NONCLIENT: 'No cliente',
  GENERIC_USERTYPE: 'tipo de cuenta',
  GENERIC_USER: 'cuenta',
  GENERIC_UPDATE: 'actualizar',
  GENERIC_CREATED: 'Creato',
  GENERIC_UPDATED: 'Actualizado',
  GENERIC_CONTENT_UPDATED: 'CONTENIDO ACTUALIZADO',
  GENERIC_WELCOME: 'Bienvenido',
  GENERIC_OFFICIALDATA: 'datos técnicos',
  GENERIC_BUSINESSNAME: 'Nombre de la empresa',
  GENERIC_OFFICIALDATA_EMPTY: 'Todavía no hay datos técnicos de esta empresa.',
  GENERIC_QUESTIONNAIRES_EMPTY: 'Todavía no hay cuestionarios para esta empresa.',
  GENERIC_CANCEL: 'no guardar',
  GENERIC_SAVE: 'guardar',
  GENERIC_ADD: 'Añadir',
  GENERIC_PARTIALSAVE: 'Guardar pero no confirmar',
  GENERIC_PRINT: 'Imprimir',
  GENERIC_FISCALCODE: 'Código fiscal',
  GENERIC_ITALY: 'Italia',
  GENERIC_FOREIGN: 'Extranjero',
  GENERIC_SELECT: 'Seleccionar',
  GENERIC_COUNTRY: 'Estado',
  GENERIC_NEW: 'Nuevo',
  GENERIC_ALREADY_SET: 'Ya presente',
  GENERIC_UNAVAILABLE: 'No disponible',
  GENERIC_CREDITS: 'Créditos',
  GENERIC_COST: 'Coste',
  GENERIC_CREDITS_LEFT: 'Créditos residuales',
  GENERIC_SEND: 'Enviar',
  GENERIC_PARTIALSEND: 'Guardar pero no enviar',
  GENERIC_ADDRESS: 'Dirección',
  GENERIC_CITY: 'Ciudad',
  GENERIC_PHONE_NUMBER: 'Número de teléfono',
  GENERIC_FISCAL_CODE_OR_ID_NUMBER: 'Código fiscal o número de registro',
  REGISTRATION_NUMBER_OR_DUNS: 'Número de registro o número de Duns',
  GENERIC_CONTINUE: 'Continuar',
  GENERIC_SHOWED: 'Ver',
  GENERIC_ORDER: 'ordenar por',
  GENERIC_READ_NOTE: 'Read note',
  GENERIC_OPEN_DETAIL: 'Open detail',
  GENERIC_CLOSE_DETAIL: 'Close detail',
  GENERIC_EMPTY_VALUE: 'n/a',
  ORDER_BY_MOST_RECENT: 'Más reciente',
  ORDER_BY_LESS_RECENT: 'Menos reciente',
  ORDER_BY_ALPHABETICAL_AZ: 'Alfabético A-Z',
  ORDER_BY_ALPHABETICAL_ZA: 'Alfabético Z-A',
  HEADER_COMPANIES: 'empresas',
  HEADER_CONTRACTS: 'contratos',
  HEADER_NOTES: 'notas',
  HEADER_REQUESTS: 'solicitudes',
  HEADER_ORDERS: 'realización de pedidos',
  HEADER_USERS: 'Cuenta',
  HEADER_ORDERS_LIST: 'Lista de pedidos',
  NAVIGATION_ITEM_ACCOUNTS: 'Cuenta',
  NAVIGATION_ITEM_ACCOUNTS_CLIENTS: 'Clientes',
  NAVIGATION_ITEM_ACCOUNTS_NON_CLIENTS: 'No clientes',
  NAVIGATION_ITEM_ACCOUNTS_NON_EDITORS: 'Editores',
  NAVIGATION_ITEM_COMPANIES: 'Empresas',
  NAVIGATION_ITEM_COMPANY: 'Mi empresa',
  NAVIGATION_ITEM_PROFILE_LOGOUT: 'Cierre de sesión',
  NAVIGATION_ITEM_PROFILE_CHANGE_PASSWORD: 'Cambiar contraseña',
  NAVIGATION_ITEM_ORDERS: 'Pedidos',
  HOME_SUBTITLE: 'Estas son las últimas notificaciones de Nando',
  LOGIN_HEADFORM: 'Introduce tus credenciales',
  ACCOUNTS_USER_CREATION_COMPANY: '¿Tienes una nueva empresa cliente?',
  ACCOUNTS_USER_CREATION_COMPANY2: '¿Tienes una nueva empresa NO cliente?',
  EDITOR_USER_CREATION_LABEL: '¿Quieres crear una nueva cuenta de editor?',
  MASTERBASE_USER_CREATION_LABEL: '¿Quieres crear una nueva cuenta principal o base?',
  MASTER_USER_CREATION_LABEL: '¿Quieres crear una nueva cuenta de director?',
  DIRECTOR_USER_CREATION_LABEL: '¿Quieres crear una nueva cuenta de comprador?',
  BUYER_USER_CREATION_LABEL: '¿Quieres crear una nueva cuenta de base?',
  REDIRECT_LOGIN: 'Ir al INICIO DE SESIÓN',
  REQUEST_TOCONFIRM: 'Solicitudes pendientes',
  ACCOUNTS_TITLE: 'Cuenta de clientes',
  ACCOUNTS_TITLE2: 'Cuenta de no clientes',
  ACCOUNTS_TITLE3: 'Cuenta de editor',
  ACCOUNTS_TOCONFIRM: 'Cuenta por confirmar',
  ACCOUNTS_ASK_CONFIRM: '¿Confirmas que quieres aprobar la siguiente cuenta?',
  ACCOUNTS_ASK_REFUSE: '¿Confirmas que quieres rechazar la siguiente cuenta?',
  ACCOUNTS_ASK_REMOVE: '¿Confirmas que quieres eliminar la siguiente cuenta?',
  DOCUMENT_COMPLETED: 'completado',
  DOCUMENT_REVIEW: 'revisión',
  DOCUMENT_INCOMPLETE: 'por completar',
  DOCUMENTS_REQUESTED: 'documentos requeridos',
  DOCUMENTS_ADD: 'Añadir datos técnicos',
  DOCUMENTS_SOURCE_NETTUNO: 'Nettuno',
  DOCUMENTS_SOURCE_CUSTOM: 'Manual',
  DOCUMENTS_EMPTY: 'No hay ningún documento disponible',
  BUSINESS_BUYERNAME: 'nombre del comprador',
  BUSINESS_BUYERNAME_SEARCH: 'nombre del comprador',
  BUSINESS_REQUESTINGCOMPANY: 'Empresa solicitante',
  BUSINESS_STATUS: 'Estado de BI',
  BUSINESS_GENERIC_DATA: 'Datos generales',
  REPORT_TITLE: 'Report',
  QUICK_REPORT_TITLE: 'Quick Report',
  BUSINESS_INFORMATION_TITLE: 'Business Information',
  BUSINESS_INFORMATION_REQUESTEDBY: 'Solicitante',
  BUSINESS_INFORMATION_BUYORDER: 'Fecha de actualización',
  BUSINESS_INFORMATION_EDITOR: 'editor',
  BUSINESS_INFORMATION_NOTES: 'Aspectos más interesantes de la encuesta para el cliente',
  BUSINESS_INFORMATION_LANGUAGE: 'Idioma',
  BUSINESS_INFORMATION_ADDRESS: 'Dirección de la sede central',
  BUSINESS_INFORMATION_NUMEMPLOYEES: 'Número de empleados',
  BUSINESS_INFORMATION_FOUNDEDIN: 'Fecha de construcción',
  BUSINESS_INFORMATION_COREBUSINESS: 'Actividad principal',
  BUSINESS_INFORMATION_ESTATE: 'Inmuebles de la sociedad',
  BUSINESS_INFORMATION_WAITING_TI: 'Estamos esperando los datos técnicos...',
  BUSINESS_INFORMATION_TECHDOC_LINK: 'enlace a los datos técnicos',
  BUSINESS_CLOSING_COMMENT: 'Cierre del informe',
  BUSINESS_INFORMATION_SAVETEXT: '¿Quieres confirmarlo como completado?',
  TECHDOC_SAVEQUESTION: '¿Quieres guardar permanentemente los datos oficiales?',
  ORDERS_WIZARD_TITLE: 'Buscar empresas',
  ORDERS_WIZARD_SEARCH_LABEL: 'Buscar:',
  ORDERS_WIZARD_RADIO_NAME: 'Denominación',
  ORDERS_WIZARD_PLACEHOLDER_PROVINCE: 'Provincia',
  ORDERS_WIZARD_INVESTIGATION_CODE: 'Código de la empresa',
  ORDERS_WIZARD_INVESTIGATION_CODE_PLACEHOLDER: 'p. ej. ADFD12',
  ORDERS_WIZARD_INVESTIGATION_SUBCODE: 'Subcódigo de la empresa',
  ORDERS_WIZARD_INVESTIGATION_SUBCODE_PLACEHOLDER: 'p. ej. ADFD12',
  ORDERS_WIZARD_FIRST_NAME_LABEL: 'Introduce el nombre de la persona de contacto de la empresa:',
  ORDERS_WIZARD_REPRESENTATIVE_FIRST_NAME_PLACEHOLDER: 'p. ej. John',
  ORDERS_WIZARD_LAST_NAME_LABEL: 'Introduce el apellido de la persona de contacto de la empresa:',
  ORDERS_WIZARD_REPRESENTATIVE_LAST_NAME_PLACEHOLDER: 'p. ej. Appleseed',
  ORDERS_WIZARD_EMAIL_LABEL: 'Introduce el correo electrónico de la persona de contacto de la empresa:',
  ORDERS_WIZARD_REPRESENTATIVE_EMAIL_PLACEHOLDER: 'por ejemplo, john.appleseed@email.com',
  ORDERS_WIZARD_PHONE_LABEL: 'Introduce el número de teléfono de la persona de contacto de la empresa:',
  ORDERS_WIZARD_REPRESENTATIVE_PHONE_PLACEHOLDER: 'p. ej. +39 345 1234567',
  ORDERS_WIZARD_REASON_LABEL: 'Notas',
  ORDERS_WIZARD_REASON_PLACEHOLDER: 'Introduce notas y puntos de interés para la encuesta...',
  ORDERS_WIZARD_BUSINESS_NAME_PLACEHOLDER: 'p. ej. Appleseed Corporation',
  ORDERS_WIZARD_FISCAL_CODE_PLACEHOLDER: 'p. ej. 0000000000',
  ORDERS_WIZARD_REA_NUMBER_PLACEHOLDER: 'p. ej. 0000000000',
  ORDERS_WIZARD_VAT_NUMBER_PLACEHOLDER: 'p. ej. 0000000000',
  ORDERS_WIZARD_ADDRESS_LABEL: 'Dirección del establecimiento a investigar',
  ORDERS_WIZARD_ADDRESS_PLACEHOLDER: 'Dirección del establecimiento',
  ORDERS_WIZARD_FOREIGN_CITY_PLACEHOLDER: 'p. ej. Londres',
  SEARCH_RESULTS: 'Resultados de la búsqueda',
  SEARCH_RESULTS_LEGAL_HEAD_OFFICE: 'Domicilio social',
  SEARCH_RESULTS_LOCATION: 'Provincia',
  SEARCH_RESULTS_LEGAL_STATUS: 'Forma jurídica',
  SEARCH_RESULTS_COREBUSINESS: 'Actividades',
  SEARCH_RESULTS_ADDRESS: 'Dirección de la sede',
  SEARCH_RESULTS_REGISTRATION_NUMBER: 'Número de registro',
  SEARCH_RESULTS_DUNS: 'Número de Duns',
  SEARCH_RESULTS_PROVINCE_REA: 'Prov./ N.º Rea',
  SEARCH_RESULTS_STATUS: 'Estado de la empresa',
  SEARCH_RESULTS_LOADING: 'Estamos cargando los resultados de la búsqueda...',
  SEARCH_COMPANY: 'Buscar empresa',
  LOGIN_TITLE: 'Entra en Nando.',
  LOGIN_SUBTITLE: 'Introduce tus credenciales a continuación.',
  LOGIN_USERNAME_LABEL: 'Dirección de correo electrónico',
  LOGIN_PASSWORD_LABEL: 'Contraseña',
  LOGIN_PASSWORD_PLACEHOLDER: 'Introduce tu contraseña',
  LOGIN_SUBMIT: 'Acceder',
  LOGIN_FORGOT_PASSWORD_CTA: '¿Has olvidado tu contraseña?',
  TABLE_GENERIC_EMPTY_LIST: 'No hay ningún elemento',
  TABLE_BI_EMPTY_LIST: 'No hay información comercial para esta empresa',
  RESET_PASSWORD_TITLE: 'Restablecer la contraseña',
  RESET_PASSWORD_SUBTITLE: 'Introduce tu nueva contraseña.',
  RESET_PASSWORD_CTA: 'Establece una nueva contraseña',
  RESET_PASSWORD_SUCCESS_TITLE: '¡Ya está hecho!',
  RESET_PASSWORD_SUCCESS_INSTRUCTIONS: 'Ahora puedes conectarte con la nueva contraseña que has elegido.',
  RESET_PASSWORD_REQUEST_TITLE: '¿Has olvidado tu contraseña?',
  RESET_PASSWORD_REQUEST_SUBTITLE: 'Escribe tu dirección de correo electrónico y te ayudaremos a recuperarla.',
  RESET_PASSWORD_REQUEST_CTA: 'Solicitar enlace de restablecimiento',
  RESET_PASSWORD_REQUEST_SUCCESS_TITLE: 'Ya casi hemos terminado...',
  RESET_PASSWORD_REQUEST_SUCCESS_INSTRUCTIONS: 'Te hemos enviado un correo electrónico a la dirección que nos has proporcionado con instrucciones sobre cómo establecer una nueva contraseña para tu cuenta.',
  RESET_PASSWORD_BACK_TO_LOGIN_CTA: 'Volver al inicio de sesión',
  RESET_PASSWORD_VALIDATION_FAILED_TITLE: 'Algo va mal...',
  CHANGE_PASSWORD_TITLE: 'Cambiar contraseña',
  CHANGE_PASSWORD_LABEL_CURRENT_PASSWORD: 'Contraseña actual',
  CHANGE_PASSWORD_LABEL_NEW_PASSWORD: 'Nueva contraseña',
  CHANGE_PASSWORD_LABEL_PASSWORD_CONFIRMATION: 'Confirmar la nueva contraseña',
  CHANGE_PASSOWRD_CTA: 'Guardar contraseña',
  CHANGE_PASSWORD_SECONDARY_CTA: 'Cancelar',
  CHANGE_PASSWORD_SUCCESS: 'La contraseña se ha actualizado correctamente.',
  ORDERS_TITLE: 'Pedidos',
  ORDERS_TITLE_PENDING: 'Pedidos pendientes',
  ORDERS_TITLE_ARCHIVED: 'Pedidos archivados',
  ORDERS_TITLE_EDITED: 'Pedidos reabiertos',
  ORDERS_QUESTIONNAIRES: 'Cuestionarios',
  ORDERS_EMPTY_LIST_MESSAGE: 'No hay pedidos disponibles',
  ORDER_MAKE: 'Crear pedido',
  QUESTIONNAIRE_CHECK_TITLE: 'formulario de verificación',
  QUESTIONNAIRE_ASSESSMENT_TITLE: 'autoevaluación',
  STATUS_APPROVED: 'Aprobado',
  STATUS_REJECTED: 'Rechazado',
  STATUS_REVIEWING: 'En revisión',
  ACCOUNT_TYPE_EDITOR: 'Editor',
  ACCOUNT_TYPE_MASTER: 'Principal',
  ACCOUNT_TYPE_DIRECTOR: 'Director',
  ACCOUNT_TYPE_BUYER: 'Comprador',
  ACCOUNT_TYPE_BASE: 'Base',
  TABLE_HEADER_NAME: 'Nombre',
  TABLE_HEADER_COMPANY: 'Empresa',
  TABLE_HEADER_STATUS: 'Estado',
  TABLE_HEADER_ACCOUNT_TYPE: 'Tipo de cuenta',
  TABLE_HEADER_INSERTED_BY: 'Añadido por',
  TABLE_HEADER_ACTIVE: 'Activo',
  TABLE_HEADER_TYPE: 'Tipo',
  TABLE_HEADER_ACCOUNTS_COUNT: 'N.º cuenta',
  TABLE_HEADER_ORDERS_COUNT: 'N.º pedidos',
  TABLE_HEADER_PENDING_ORDERS_COUNT: 'N.º pedidos pendientes',
  TABLE_HEADER_COUNTRY: 'País',
  MODAL_TITLE_CREATE_ACCOUNT: 'Crear una nueva cuenta {{userType}}',
  MODAL_TITLE_APPROVE_ACCOUNT: 'Aprobar cuenta',
  MODAL_TITLE_REJECT_ACCOUNT: 'Rechazar cuenta',
  CREATE_ACCOUNT_COMPANY_LABEL: 'Empresa',
  CREATE_ACCOUNT_COMPANY_PLACEHOLDER: 'Seleccionar una empresa...',
  CREATE_ACCOUNT_FIRST_NAME_LABEL: 'Nombre',
  CREATE_ACCOUNT_FIRST_NAME_PLACEHOLDER: 'John',
  CREATE_ACCOUNT_LAST_NAME_LABEL: 'Apellido',
  CREATE_ACCOUNT_LAST_NAME_PLACEHOLDER: 'Appleseed',
  CREATE_ACCOUNT_EMAIL_LABEL: 'Correo electrónico',
  CREATE_ACCOUNT_EMAIL_PLACEHOLDER: 'john.appleseed@email.com',
  CREATE_ACCOUNT_CTA_CREATE: 'Crear',
  CREATE_ACCOUNT_CTA_CANCEL: 'Cancelar',
  APPROVE_ACCOUNT_CTA: 'Aprobar',
  REJECT_ACCOUNT_CTA: 'Rechazar',
  APPROVE_REJECT_ACCOUNT_CTA_CANCEL: 'Cancelar',
  REJECT_ACCOUNT_REASON_LABEL: 'Motivación',
  REJECT_ACCOUNT_REASON_PLACEHOLDER: '(Opcional) Escribe el motivo del rechazo...',
  ORDERS_PLACE_DESCRIPTION: '¿Quieres saber más sobre una empresa?',
  ORDERS_PLACE_CTA: 'Nuevo pedido',
  ORDERS_REQUEST_CTA: 'Solicita',
  QUESTIONNAIRE_EXPORT_FACSIMILE: 'Facsímil de exportación',
  QUESTIONNAIRE_SA_SEND_QUESTION: '¿Quieres enviar definitivamente una nueva versión de la autoevaluación?',
  QUESTIONNAIRE_CF_SEND_QUESTION: '¿Quieres enviar definitivamente una nueva versión del formulario de verificación?',
  QUESTIONNAIRE_ITEM_INPUT_PLACEHOLDER: 'Introduce {{fieldName}}',
  QUESTIONNAIRE_ITEM_TEXTAREA_PLACEHOLDER: 'Introduce el texto',
  QUESTIONNAIRE_ITEM_INPUT_GENERIC_PLACEHOLDER: 'Introduce el valor',
  TABLE_CONTRACT_EMPTY_LIST: 'No hay contrato para esta empresa',
  TABLE_CONTRACT_VALID_FROM: 'Válido desde',
  TABLE_CONTRACT_VALID_UNTIL: 'Válido hasta',
  TABLE_CONTRACT_NUMBER: 'Número',
  TABLE_CONTRACT_DOCUMENT: 'Documento',
  TABLE_CONTRACT_CREDITS: 'Créditos',
  CONTRACT_EDIT: 'Modificación del contrato',
  CONTRACT_CREATE: 'Crear contrato',
  CONTRACT_NUMBER: 'Número de contrato',
  CONTRACT_VALID_FROM: 'Contrato válido desde',
  CONTRACT_VALID_UNTIL: 'Contrato válido hasta',
  CONTRACT_DOCUMENT: 'Adjuntar un nuevo documento',
  CONTRACT_EDIT_CANCEL: 'Cancelar',
  CONTRACT_CREATION_LABEL: '¿Quieres firmar un nuevo contrato?',
  CONTRACT_CREATION_BUTTON: 'crear contrato',
  PRICE_LIST: 'Lista de precios',
  USE_DEFAULT_PRICE_LIST: 'Utilizar la lista de precios por defecto',
  QUESTIONNAIRE_SEND_QUESTION: '¿Quieres enviar esta versión de {{title}} definitivamente?',
  TABLE_EMPTY_REVIEWING_ACCOUNTS: 'No hay cuentas que aprobar en este momento.',
  GO_TO_NANDO_CTA: 'Ir a Nando',
  GO_TO_FORM_CTA: 'Más información',
  CONFIRM_DELETE_DOCUMENT_MESSAGE: '¿Confirmas que quieres eliminar el documento?',
  QUESTIONNAIRE_DOCUMENTS_NOT_UPLOADED: 'No se ha cargado ningún documento',
  ORDER_CONTACT_PERSON_TITLE: 'Persona de contacto de la empresa',
  ORDER_CONTACT_PERSON_NAME: 'Nombre',
  ORDER_CONTACT_PERSON_EMAIL: 'Dirección de correo electrónico',
  ORDER_CONTACT_PERSON_PHONE: 'Teléfono',
  ORDER_INVESTIGATION_TITLE: 'Códigos de investigación',
  ORDER_INVESTIGATION_UPDATE: 'Actualizar códigos',
  ORDER_REASON_TITLE: 'Notas',
  QUESTIONNAIRE_REJECT: 'Cuestionario de rechazo',
  QUESTIONNAIRE_APPROVE: 'Aprobar el cuestionario',
  QUESTIONNAIRES_TOCONFIRM: 'Cuestionarios por confirmar',
  HOME_SHOW_PREV: 'Mostrar la página anterior',
  HOME_SHOW_NEXT: 'Mostrar la página siguiente',
  COMPLIANCE_TOOLTIP: 'Los resultados positivos indicados a continuación podrían atribuirse a homónimos. Solicite una profundización por email',
  COMPANY_BUDGETS_CONTRACT: 'Todos los presupuestos asignados a las cuentas se refieren al siguiente contrato activo:',
  COMPANY_BUDGETS_CONTRACT_NUMBER: 'Número',
  COMPANY_BUDGETS_CONTRACT_CREDITS: 'Créditos',
  COMPANY_BUDGETS_CONTRACT_VALID_FROM: 'Válido desde',
  COMPANY_BUDGETS_CONTRACT_VALID_UNTIL: 'Válido hasta',
  COMPANY_BUDGETS_CONTRACT_EDIT_CTA: 'Si quieres cambiarlo, ve a la sección de CONTRATOS de la empresa.',
  COMPANY_STRUCTURE_DIRECTOR_EMPTY: 'No hay cuenta de DIRECTOR disponible.',
  COMPANY_STRUCTURE_BASE_EMPTY: 'No hay cuenta BASE disponible.',
  USERS_BASE_LIST: 'Base',
  COMPLETE_ORDER_MODAL_TITLE: 'Pedido completo',
  COMPLETE_ORDER_MODAL_DESCRIPTION_GENERAL: 'Estás a punto de completar el pedido realizado por {{buyerName}} para la empresa {{companyName}}.',
  COMPLETE_ORDER_MODAL_DESCRIPTION_ATTACH_MESSAGE: '{{buyerName}} recibirá una notificación por correo electrónico. Adjunta un comentario final que se adjuntará al informe final del pedido.',
  COMPLETE_ORDER_MODAL_MESSAGE_LABEL: 'Conclusiones',
  COMPLETE_ORDER_MODAL_MESSAGE_PLACEHOLDER: 'Escribe el comentario que quieres adjuntar al informe',
  COMPLETE_ORDER_MODAL_CONFIRM_CTA: 'Confirmar',
  COMPLETE_ORDER_MODAL_CANCEL_CTA: 'Cancelar',
  ORDER_COMPLETE_CTA: 'Pedido completo',
  REOPEN_ORDER_MODAL_DESCRIPTION_ATTACH_MESSAGE: '{{buyerName}} recibirá una notificación por correo electrónico. Si quieres, puedes adjuntar un mensaje que se entregará con la notificación.',
  REOPEN_ORDER: 'Reabrir el pedido',
  REOPEN_ORDER_MODAL_MESSAGE_LABEL: 'Mensaje',
  REOPEN_ORDER_MODAL_DESCRIPTION_GENERAL: 'Estás a punto de reabrir el pedido realizado por {{buyerName}} para {{companyName}}.',
  NO_USERS_TO_CONFIRM: 'No hay cuentas que confirmar',
  NO_QUESTIONNAIRES_TO_CONFIRM: 'No hay cuestionarios que confirmar',
  BUSINESS_INFORMATION_EMPTY_LIST: 'No hay elementos que mostrar.',
  SCORE_DESCRIPTION: 'Descripción de la puntuación',
  ORDER_RECAP: 'Resumen de pedidos',
  TABLE_HEADER_QUICK_SCORE: 'Quick Report',
  TABLE_HEADER_BASE_SCORE: 'BI',
  TABLE_HEADER_NANDO_SCORE: 'Nando Rating',
  TABLE_HEADER_NANDO_PLUS_SCORE: 'Nando Rating+',
  REPUTATION: 'Reputación y credibilidad',
  PRODUCT_DESCRIPTION_QUICK_REPORT: 'Quick Report',
  PRODUCT_DESCRIPTION_BASE: 'Business Information',
  PRODUCT_DESCRIPTION_TOP: 'Nando Rating',
  PRODUCT_DESCRIPTION_PREMIUM: 'Nando Rating+',
  PRODUCT_DESCRIPTION_QUALITY_SCORE: 'Quality Score',
  PRODUCT_DESCRIPTION_MATCH_SCORE: 'Match Score',
  PRODUCT_DESCRIPTION_ALERTS_CHECK: 'Alerts Check',
  PRODUCT_DESCRIPTION_COMPLIANCE: 'Compliance',
  PRODUCT_DESCRIPTION_PEP: 'Personas politicamente expuestas',
  PRODUCT_DESCRIPTION_LEGAL_EVENTS: 'Actos legales',
  ORDERS_LIST_PRODUCT_DESCRIPTION_QUICK_REPORT: 'QUICK REPORT',
  ORDERS_LIST_PRODUCT_DESCRIPTION_BASE: 'BUSINESS INFORMATION',
  ORDERS_LIST_PRODUCT_DESCRIPTION_TOP: 'NANDO RATING',
  ORDERS_LIST_PRODUCT_DESCRIPTION_PREMIUM: 'NANDO RATING+',
  ORDERS_WIZARD_PRODUCT_DESCRIPTION_QUICK_REPORT: 'Report en tiempo real sobre empresas con Rating, Opinión crediticia, Compliance checks, Verificación de negatividades y del Proprietario Beneficiario. El Rating y la Opinión crediticia se calculan mediante un algoritmo automático.',
  ORDERS_WIZARD_PRODUCT_DESCRIPTION_BASE: 'Análisis de una empresa con evasion diferida y con una evaluación realizada por un analista a partir de las informaciónes presente en el QUICK REPORT. El Rating y la Opinión crediticia son validados por el analista.',
  ORDERS_WIZARD_PRODUCT_DESCRIPTION_TOP: 'Integración en la BUSINESS INFORMATION de las informaciones surgidas en el cuestionario CHECK FORM, que es compilado directamente por la empresa analizada y que permite obtener elementos actualizados como Certificaciones, Regularidad en el pago de impuestos, cualquier Covid- 19 impactos, etc. Este análisis asigna un Rating específico.',
  ORDERS_WIZARD_PRODUCT_DESCRIPTION_PREMIUM: 'Integración del NANDORATING con el cuestionario SELF ASSESSMENT compilado para evaluar una o más fábricas y sitios de una empresa. El análisis de los resultados asigna un Rating específico.',
  BI_SAVE_AND_CONFIRM_CTA: 'Guardar y confirmar',
  COMPANY_EDIT: 'Editar empresa',
  TABLE_HEADER_LAST_UPDATED_AT: 'Última actualización',
  BUSINESS_INFORMATION_TRUST_STATEMENT_LABEL: 'Opinion crediticia',
  SCORE_LEGEND_TITLE: 'Leyenda',
  SCORE_LEGEND_DESCRIPTION_CRITICAL: 'Crítico',
  SCORE_LEGEND_DESCRIPTION_WEAK: 'Débil',
  SCORE_LEGEND_DESCRIPTION_FAIR: 'Discreto',
  SCORE_LEGEND_DESCRIPTION_GOOD: 'Bueno',
  SCORE_LEGEND_DESCRIPTION_EXCELLENT: 'Excelente',
  SCORE_LEGEND_BASE_DESCRIPTION_CRITICAL: 'Empresa extremadamente vulnerable, atrasada en los pagos con muy alto nivel de endeudamiento y dificultades organizativas. Presencia de negatividad oficial y/o empresa de reciente creación y en fase de puesta en marcha.',
  SCORE_LEGEND_BASE_DESCRIPTION_WEAK: 'Empresa actualmente vulnerable. La solvencia de las deudas asumidas depende principalmente de condiciones económicas y financieras favorables. Datos de balance con tendencia negativa. Surge una deuda elevada pero aún sustentable y/o una Compañía que solo ha estado operativa por poco tiempo y necesita consolidación. Empresa poco conocida en el mercado.',
  SCORE_LEGEND_BASE_DESCRIPTION_FAIR: 'Empresa con capacidad adecuada para cumplir con las obligaciones asumidas. Sin embargo, las condiciones económicas adversas pueden generar una menor capacidad para cumplir con las obligaciones asumidas. Compañía de tamaño modesto y con resultados económicos / patrimoniales justos en general. Empresa suficientemente conoscida en el sector al que pertenece.',
  SCORE_LEGEND_BASE_DESCRIPTION_GOOD: 'Empresa con buena capacidad para respetar los compromisos asumidos. Mostró un buen equilibrio financiero y económico y una buena estructura. Los datos del balance son satisfactorios y con tendencias positivas.',
  SCORE_LEGEND_BASE_DESCRIPTION_EXCELLENT: 'Empresa con excelente capacidad para cumplir con las obligaciones asumidas y con constante crecimiento en los últimos años. Estructura consolidada. Empresa sólida con excelentes resultados económico-financieros.',
  SCORE_LEGEND_TOP_DESCRIPTION_CRITICAL: 'Compañía que opera en áreas donde existe un riesgo país muy alto. Tiene varios sitios de producción no controlados o en áreas con un riesgo país muy alto. Certificaciones de proceso ausentes o inadecuadas. Cumplimiento tributario ausente o no conforme. Poca colaboración en la elaboración de perfiles de empresas.',
  SCORE_LEGEND_TOP_DESCRIPTION_WEAK: 'Compañía que opera en áreas de alto riesgo país. Tiene varios sitios de producción no controlados o en áreas con alto riesgo país. Las certificaciones de proceso vencieron y no se renovaron. Cumplimiento tributario ausente o no conforme. Poca colaboración en la elaboración de perfiles de empresas.',
  SCORE_LEGEND_TOP_DESCRIPTION_FAIR: 'Compañía que opera en áreas donde existe un riesgo país medio. Tiene varios sitios de producción controlados y en áreas con riesgo país medio. Procesar certificaciones en fase de caducidad o en fase de renovación. Cumplimiento tributario debido. Colaboración discreta en la elaboración de perfiles de la empresa.',
  SCORE_LEGEND_TOP_DESCRIPTION_GOOD: 'Compañía que opera en áreas de bajo riesgo país. Tiene varios sitios de producción controlados y en áreas con bajo riesgo país. Pocas certificaciones de procesos activos. Cumplimiento tributario actualizado. Buena cooperación en la elaboración de perfiles de empresas.',
  SCORE_LEGEND_TOP_DESCRIPTION_EXCELLENT: 'Compañía que opera en áreas donde el riesgo país es mínimo. Tiene varios sitios de producción controlados y en áreas con mínimo riesgo país. Certificaciones de proceso completo. Cumplimiento tributario actualizado. Excelente colaboración en la elaboración de perfiles de empresas.',
  SCORE_LEGEND_PREMIUM_DESCRIPTION_CRITICAL: 'Establecimiento mal estructurado y desorganizado. Ubicado en un país con un riesgo país muy alto. Medidas de seguridad ausentes o totalmente inadecuadas. Sistemas de safety ausentes o totalmente inadecuados. Falta de sistemas de continuidad energética e infraestructuras tecnológicas ausentes o totalmente inadecuadas.',
  SCORE_LEGEND_PREMIUM_DESCRIPTION_WEAK: 'Establecimiento mediocre y mal organizado. Ubicado en un país de alto riesgo país. Deficientes medidas de safety. Sistemas de seguridad deficientes. Falta de sistemas de continuidad energética e infraestructuras tecnológicas inadecuadas.',
  SCORE_LEGEND_PREMIUM_DESCRIPTION_FAIR: 'Establecimiento discretamente organizado. Ubicado en un país con riesgo país medio. Medidas de safety discretas. Sistemas de seguridad discretos. Presencia de sistemas de continuidad energética e infraestructuras tecnológicas discretas.',
  SCORE_LEGEND_PREMIUM_DESCRIPTION_GOOD: 'Establecimiento bien organizado. Ubicado en un país de bajo riesgo país. Buenas medidas de safety. Buenos sistemas de seguridad. Presencia de sistemas de continuidad energética y buenas infraestructuras tecnológicas.',
  SCORE_LEGEND_PREMIUM_DESCRIPTION_EXCELLENT: 'Establecimiento en perfecto estado y bien organizado. Ubicado en un país con mínimo riesgo país. Excelentes medidas de safety. Excelentes sistemas de seguridad. Presencia de sistemas de continuidad energética e infraestructuras tecnológicas de última generación.',
  QUESTIONNAIRE_PREVIEW_SCORE_LABEL: 'Puntuación parcial resultante de las respuestas al cuestionario',
  QUESTIONNAIRE_FINAL_SCORE_LABEL: 'Puntuación final',
  GENERIC_REQUIRED_FIELDS: 'Campos obligatorios',
  GENERIC_OPTIONAL_FIELDS: 'Campos opcionales',
  PLACING_ORDER_LOADING: 'Estamos procesando tu pedido. Solo tardarás unos segundos...',
  QUESTIONNAIRE_MAX_SIZE_UPLOAD: 'Máximo 50 MB',
  PRIVACY_POLICY_ACCEPTED: 'He leído y acepto ',
  UPDATED: 'Actualizado el',
  COMING_SOON: 'Próximamente',
  NO_MATCHES_FOUND: 'No errores detectados',
  MATCHES_FOUND: 'Errores detectados',
  VALUES_YES: 'Sí',
  VALUES_NO: 'No',
  NO_ELEMENTS_TO_VIEW: 'No hay elementos para mostrar',
  SET_QUESTIONNAIRE_TO_DRAFT: 'Devuelve el Cuestionario en borradores',
  SET_QESTIONNAIRE_TO_DRAFT_MESSAGE: 'Indica a continuación los cambios que hay que hacer en el cuestionario (obligatorio).',
  SET_BUSINESSINFO_TO_DRAFT: 'Devuelve el Información comercial en borradores',
  SET_BUSINESSINFO_TO_DRAFT_MESSAGE: 'ndica a continuación los cambios que hay que hacer en el Información comercial (obligatorio).',
  SET_TECH_DOC_TO_DRAFT: 'Devuelve datos técnicos en borradores',
  GENERIC_CONTACT: 'Contactos',
  GENERIC_WEBSITE: 'Página web',
  GENERIC_ELECTRONIC_INVOICE: 'Factura electrónica SDI',
  GENERIC_VARIOUS: 'Varios',
  ORDERS_SUMMARY: 'Resumen de pedidos',
  GENERIC_TECH_DOC: 'Documento técnico',
  DUPLICATE_FIELDS: 'Duplicar campos',
  GENERIC_REMOVE: 'Borrar',
  USER_EDIT: 'Editar usuario',
  USER_REMOVE: 'Borrar usuario',
};

export default translations;
